import React, { useContext } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { LicenseManager } from 'ag-grid-enterprise';
import { AgGridTableWrapper } from '@mummssoftware/common-ui';
import { AppBereavementContext } from '../Context/AppBereavementContext';
import { CGTable } from './CGTable';
import { BereavementTable } from './BereavementTable';
import { TextDiv } from '../../components/layout/WrapperDiv';
import { text } from './constants';

import 'ag-grid-community/dist/styles/ag-grid.css';
import '@mummssoftware/common-ui/style/css/ag-theme-hummingbird.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';

LicenseManager &&
  LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_KEY as string);

interface TablesProps {
  viewModePrint?: boolean;
  smallWidget?: boolean;
}

export const Tables = ({ viewModePrint, smallWidget }: TablesProps) => {
  const {
    props: {
      grid: { className },
    },
  } = useTheme() as any;
  const { showTable } = useContext(AppBereavementContext);

  return (
    <AgGridTableWrapper
      id="bereav-tables-wrapper"
      className={`${className} light max-width`}
      printMode={viewModePrint}
    >
      {showTable && <BereavementTable smallWidget={smallWidget} />}
      <TextDiv>{text}</TextDiv>
      <CGTable smallWidget={smallWidget} />
    </AgGridTableWrapper>
  );
};

export default Tables;
